import { render, staticRenderFns } from "./DevolucionReporteFacturacion.vue?vue&type=template&id=2cdd4b8e"
import script from "./DevolucionReporteFacturacion.vue?vue&type=script&lang=js"
export * from "./DevolucionReporteFacturacion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports